<template>
  <div>
    <el-tabs class="grid-content content-margin">
      <el-tab-pane :label="$t(`message.${this.title}`)">
        <table>
          <!-- 头部按钮 -->
          <tr >
            <OrgButtonArea
              @onEdit="onEdit"
              @onSave="onSave"
              @onRefresh="onRefresh"
              @onCancel="onCancel"
              @onBack="onBack"
              @onAdd="onAdd"
              ref="orgButton"
              :isAddMode="this.isAddMode"
              :isEditMode="this.isEditMode"
            ></OrgButtonArea>
            <el-divider></el-divider>
          </tr>

          <tr>
            <div
              :style="{
                height: this.clientHeight + 'px',
                'overflow':'auto'
              }"
            >
              <table class="simpleRow" >
                <tr>
                  <td v-show="!isAddMode" width='10%' align='left'>
                    <span class="simpleLabel">ID:</span>
                  </td>
                  <td v-show="!isAddMode" width='35%'>
                    <el-input
                      v-model="organizationid"
                      size="small"
                      :disabled="true"
                    />
                  </td>
                  <td width='5%'></td>
                  <td width='10%' align='left'>
                    <span class="simpleLabel">{{$t('message.名称')}}</span>
                  </td>
                  <td width='40%'>
                    <el-input
                      v-model="serverData.name"
                      size="small"
                      :disabled="!isEditMode && !isAddMode"
                      :placeholder="$t('message.请输入组织名称')"
                    />
                  </td>
                </tr>
              </table>

              <table class="simpleRow">
                <tr>
                  <td width='10%' align='left'>
                    <span class="simpleLabel">{{$t('message.状态')}}</span>
                  </td>
                  <td>
                    <el-radio-group
                      v-model="serverData.state"
                      :disabled="!isEditMode && !isAddMode"
                    >
                      <el-radio :label="0">{{$t('message.普通')}}</el-radio>
                      <el-radio :label="1">{{$t('message.禁用')}}</el-radio>
                      <el-radio :label="2">{{$t('message.删除')}}</el-radio>
                    </el-radio-group>
                  </td>
                </tr>
              </table>

              <table class="simpleRow">
                <tr>
                  <td width='10%' align='left'>
                    <span class="simpleLabel">{{$t('message.备注')}}</span>
                  </td>
                </tr>
                <tr>
                  <td width='90%'>
                    <el-input
                      type="textarea"
                      :rows="3"
                      :placeholder="$t('message.请输入备注内容')"
                      v-model="serverData.comment"
                      :disabled="!isEditMode && !isAddMode"
                    >
                    </el-input>
                  </td>
                </tr>
              </table>

              <!-- 编辑修改信息 -->
              <div v-show="!isAddMode">
                <el-divider></el-divider>
                <EditInfo
                ref="oeei"
                  v-show="!isAddMode"
                  :createdate="serverData.createdate"
                  :editdate="serverData.editdate"
                ></EditInfo>
              </div>
            </div>
          </tr>
        </table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import EditInfo from "@/components/Organization/EditInfo.vue";
import OrgButtonArea from "@/components/Organization/OrgButtonArea.vue";
import {rejecthttp,changeflagCLOSED} from "@/utils/request";

export default {
  name: "OrganizationEdit",

  components: {
    EditInfo,
    OrgButtonArea,
  },

  props: {
    organizationid: null,
    clientHeight: 0,
    isAddMode: false,
  },

  data() {
    return {
      isEditMode: false,
      title: "组织信息",
      serverData: {
        appid: 188,
        state: 0,
        name: "",
      },
    };
  },

  methods: {
    onEdit() {
      this.isEditMode = true;
    },

    onCancel() {
      this.isEditMode = false;
    },

    //刷新当前组织信息
    onRefresh() {
      if (this.organizationid == null) {
        return;
      }
      rejecthttp(true,'get',"/manage/organization/main/getinfo",{
            appid: this.serverData.appid,
            organizationid: this.organizationid,
          },this,(doc) => {
            changeflagCLOSED(doc,0,this)
            if(doc.data.Code == "MSGKEY_OK"){
              this.serverData = doc.data.data;
            this.$refs.oeei.getServerData(doc.data.exData.datas);
            }
            })
      // this.$http
      //   .get("/manage/organization/main/getinfo", {
      //     params: {
      //       appid: this.serverData.appid,
      //       organizationid: this.organizationid,
      //     },
      //   })
      //   .then((doc) => {
      //     if (doc.data.Code != "MSGKEY_OK") {
      //       this.$message({
      //         type: "error",
      //         message: doc.data.Message,
      //       });
      //     } else {
      //       this.serverData = doc.data.data;
      //       this.$refs.oeei.getServerData(doc.data.exData.datas);
      //     }
      //   });
    },

    onSave() {
      if (this.serverData.name.length == 0) {
        this.$message({
          type: "error",
          message: this.$t('message.组织名称不能为空'),
        });
        return;
      }
      rejecthttp(true,'post',"/manage/organization/main/updateorganization",this.serverData,this,(doc) => {
            changeflagCLOSED(doc,1,this)
            if(doc.data.Code == "MSGKEY_OK"){
              this.onBack();
            }
            })
      // this.$http
      //   .post("/manage/organization/main/updateorganization", this.serverData)
      //   .then((doc) => {
      //     if (doc.data.Code != "MSGKEY_OK") {
      //       this.$message({
      //         type: "error",
      //         message: doc.data.Message,
      //       });
      //     } else {
      //       this.$message({
      //         type: "success",
      //         message: "保存成功",
      //       });
      //       this.onBack();
      //     }
      //   });
    },

    onBack() {
      this.$emit("onBack");
    },

    //添加组织
    onAdd() {
      if (this.serverData.name.length == 0) {
        this.$message({
          type: "error",
          message: this.$t('message.组织名称不能为空'),
        });
        return;
      }
      rejecthttp(true,'post',"/manage/organization/main/addorganization",this.serverData,this,(doc) => {
            changeflagCLOSED(doc,1,this)
            if(doc.data.Code == "MSGKEY_OK"){
              this.onBack();
            }
            })
      // this.$http
      //   .post("/manage/organization/main/addorganization", this.serverData)
      //   .then((doc) => {
      //     if (doc.data.Code != "MSGKEY_OK") {
      //       this.$message({
      //         type: "error",
      //         message: doc.data.Message,
      //       });
      //     } else {
      //       this.$message({
      //         type: "success",
      //         message: doc.data.Message,
      //       });
      //       this.onBack();
      //     }
      //   });
    },
  },

  mounted: function () {},

  watch: {
    clientHeight: {
      handler(val, oldVal) {},
      deep: true,
      immediate: true,
    },
    isAddMode: {
      handler(val, oldVal) {
        if (val == true) {
          this.title = "添加组织";

          //清空旧数据
          for (let key in this.serverData) {
            if (key != "appid" && key != "state") {
              this.serverData[key] = null;
            }
          }
          console.log(this.serverData);
        } else {
          this.title = "组织信息";
        }
      },
      deep: true,
      immediate: true,
    },
    organizationid: {
      handler(val, oldVal) {
        console.log("organizationid change");
        this.onRefresh();
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Organization/OrganizationEdit.vue